import { JSONContent } from '@tiptap/core';

// Comment content is a string: new comments store serialised ProseMirror JSON, pre-feature comments
// are plain text. These helpers handle both formats.

export function parseCommentContent(content: string): JSONContent | string {
  if (!content) {
    return '';
  }
  try {
    const parsed = JSON.parse(content);
    if (parsed && typeof parsed === 'object' && parsed.type) {
      return parsed as JSONContent;
    }
    return content;
  } catch {
    return content;
  }
}

export function commentContentToText(content: string): string {
  const parsed = parseCommentContent(content);
  if (typeof parsed === 'string') {
    return parsed;
  }
  return jsonToText(parsed);
}

function jsonToText(node: JSONContent): string {
  if (node.type === 'text') {
    return node.text ?? '';
  }
  if (node.type === 'mention') {
    return `@${node.attrs?.label ?? ''}`;
  }
  const children = (node.content ?? []).map(jsonToText).join('');
  return node.type === 'paragraph' ? `${children}\n` : children;
}
